import Swiper, {Navigation} from 'swiper';

const initStepsSlider = (wrapper) => {
    const options = {
        modules      : [Navigation],
        loop         : false,
        speed        : 600,
        spaceBetween : 32,
        slidesPerView: 'auto',
        navigation   : {
            nextEl: '.j-steps-next',
            prevEl: '.j-steps-prev'
        }
    };

    const slider = new Swiper(wrapper, options);

    return slider;
};

export {initStepsSlider};
